import axios from "axios";
import {
  __BR_ATTENDEES_PAGINATED__,
  __BR_MY_MEETINGS_SLOTS__,
  __BR_SLOT_BLOCK__,
  __BR_SLOT_UNBLOCK__,
  __BR_DECLINE_MEETING__,
  __BR_ACCEPT_MEETING__,
  __BR_REQUEST_MEETING__,
  __BR_AVAILABLE_MEETINGS_SLOTS__,
  __BR_CONFIGURATION__,
  __BR_CALENDAR_UNBLOCK__,
  __BR_CALENDAR_BLOCK__,
  __BR_EXPORT_CALENDAR_PDF__,
  __BR_EXHIBITOR_EXTRAFIELDS_SCHEMA__,
  __API_EXHIBITOR_REPRESENTATIVE__,
  __BR_FAVORITES__,
  __BR_ME__,
  __BR_EXHIBITORS__,
  __BR_ATTENDEE_IMAGE_UPLOAD__,
} from "../consts/consts";
import MyStorage from "../components/Storage";
import { __API_LOGS__ } from "../consts/consts";
import Storage from "../components/Storage";
import { store } from "../store";
import { setBusinessRoundEnabled } from "../redux/actions/businessRounds.actions";
import { extractApiErrorCode, extractApiErrorMessage } from "../utils/apiErrorCode";

//1 - Hostedbuyer vs Exhibitors
//2 - All V All
//3 - Attendees V Exhibitors

//0 - Attendees
//1 - Exhibitor
//2 - Hostedbuyer

export async function getCounterParts(configuration) {
  const counterpartsDictionary = {
    1: {
      exhibitor: 2,
      hostedbuyer: 1,
    },
    2: {},
    3: {
      attendee: 1,
      exhibitor: 0,
    },
  };
  const registationType = Storage.getRegistrationType()?.toLowerCase().replace(/\s+/g, '');

  try {
    const options = {
      url:
        __BR_ATTENDEES_PAGINATED__ +
        "?currentPage=1&resultsPerPage=3000&searchString=&orderByFields=Person.Company&IsBusinessRound=true",
      method: "GET",
      headers: {
        registrationCode: MyStorage.getPersonRegistrationCode(),
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
        token: MyStorage.getJwtToken(),
      },
    };
    // En modo RegistrationGroup el server precalcula canMeetTo por par,
    // así que no aplicamos filtro client-side por registrationType.
    const matchmakingMode = store.getState().businessRoundsReducer.businessRoundMatchmakingMode;
    const isLegacyMode = matchmakingMode !== 'RegistrationGroup';
    if (isLegacyMode && configuration != 2){
        //La configuracion 2 es Todos vs Todos, entonces no aplico filtro
        const registationTypeValue =
        counterpartsDictionary[configuration][registationType];

      if (registationTypeValue) {
        options.url += `&registrationtype=${counterpartsDictionary[configuration][registationType]}`;
      }
    }
    const { data } = await axios(options);
    // const counterpartsWithExhibitor = data.Items.filter(
    //   (attendee) => attendee.exhibitor
    // );
    // const counterpartsWithoutExhibitor = data.Items.filter(
    //   (attendee) => !attendee.exhibitor
    // );

    // counterpartsWithExhibitor.sort((a, b) =>
    //   a.exhibitor.name.localeCompare(b.exhibitor.name)
    // );
    // counterpartsWithoutExhibitor.sort((a, b) =>
    //   a.firstName.localeCompare(b.firstName)
    // );

    // const counterparts = counterpartsWithExhibitor.concat(
    //   counterpartsWithoutExhibitor
    // );
    const counterparts = data.Items || [];
    if (counterparts.length > 0) {
      counterparts.sort((a, b) => a.lastName.localeCompare(b.lastName));
    }
    return counterparts;
  } catch (error) {
    handleError(
      error,
      "getCounterParts - Pedir el listado de personas habilitadas para reuniones"
    );
    throw error;
  }
}

// Directorio de networking: TODOS los asistentes del evento (sin filtro
// IsBusinessRound ni registrationtype). Se usa cuando el evento no tiene BR.
export async function getAllAttendees() {
  try {
    const options = {
      url:
        __BR_ATTENDEES_PAGINATED__ +
        "?currentPage=1&resultsPerPage=3000&searchString=&orderByFields=Person.Company",
      method: "GET",
      headers: {
        registrationCode: MyStorage.getPersonRegistrationCode(),
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
        token: MyStorage.getJwtToken(),
      },
    };
    const { data } = await axios(options);
    const attendees = (data && data.Items) || [];
    if (attendees.length > 0) {
      attendees.sort((a, b) => (a.lastName || "").localeCompare(b.lastName || ""));
    }
    return attendees;
  } catch (error) {
    handleError(error, "getAllAttendees - Directorio de networking");
    throw error;
  }
}

export async function getCalendar() {
  const options = {
    url: __BR_MY_MEETINGS_SLOTS__ + MyStorage.getIdRegistration(),
    headers: {
      registrationCode: MyStorage.getPersonRegistrationCode(),
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
      token: MyStorage.getJwtToken(),
    },
  };
  try {
    const { data } = await axios(options);
    const meetingDays = [];
    const meetings = [];

    data.forEach((slot) => {
      const date = slot.meetingStartDateTime.split("T")[0];
      if (!meetingDays.includes(date)) {
        meetingDays.push(date);
      }
    });

    meetingDays.forEach((day) => {
      const dayMeetings = data.filter(
        (slot) => slot.meetingStartDateTime.split("T")[0] === day
      );
      meetings.push({
        date: day,
        meetings: dayMeetings,
      });
    });

    return meetings;
  } catch (error) {
    handleError(error, "getCalendar - Pedir mi agenda");
    console.log(error);
    throw error;
  }
}

// Cambia la foto de perfil. Devuelve el pictureId nuevo.
//
// Dos detalles que importan:
//  - Va como FormData REAL. frontendcongress manda un objeto plano con
//    Content-Type multipart, y axios en ese caso lo serializa como JSON.
//  - NO se fija el Content-Type a mano: el navegador tiene que ponerlo con su
//    boundary. Fijarlo sin boundary es la forma clásica de romper un multipart.
export async function uploadProfilePicture(file) {
  const formData = new FormData();
  formData.append("vImage1", file);
  const { data } = await axios.post(__BR_ATTENDEE_IMAGE_UPLOAD__, formData, {
    headers: {
      Accept: "application/json",
      registrationCode: MyStorage.getPersonRegistrationCode(),
      idEvent: MyStorage.getIdEvent(),
    },
  });
  return (data && data.pictureId) || null;
}

// Mi propio perfil (attendees/me).
export async function getMyProfile() {
  try {
    const { data } = await axios.get(__BR_ME__, {
      headers: {
        registrationCode: MyStorage.getPersonRegistrationCode(),
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
        token: MyStorage.getJwtToken(),
      },
    });
    return data || null;
  } catch (error) {
    console.warn("getMyProfile falló", error && error.message);
    return null;
  }
}

// ===== Favoritos =====
// La shortlist vive en el servidor (antes era localStorage y no viajaba entre
// dispositivos). El idRegistration lo saca el backend del token.
export const FAVORITE_TYPE_EXHIBITOR = 0;

function favoritesHeaders() {
  return {
    registrationCode: MyStorage.getPersonRegistrationCode(),
    Accept: "application/json",
    "Content-Type": "application/json;charset=UTF-8",
    token: MyStorage.getJwtToken(),
  };
}

// Devuelve null (no []) cuando el endpoint no está disponible, para que el
// llamador distinga "no tenés favoritos" de "el backend todavía no lo expone"
// y pueda caer a la copia local. Al momento de escribir esto el endpoint
// responde 404 en producción: existe solo en el entorno de desarrollo.
export async function getFavorites(type) {
  try {
    const url = type == null ? __BR_FAVORITES__ : `${__BR_FAVORITES__}?type=${type}`;
    const { data } = await axios.get(url, { headers: favoritesHeaders() });
    // Sin utcTimeStamp el backend ya devuelve solo los activos, pero filtramos
    // por las dudas para no marcar como favorito algo dado de baja.
    return Array.isArray(data) ? data.filter((f) => !f.deleted) : [];
  } catch (error) {
    console.warn("Favoritos no disponibles en el servidor", error && error.message);
    return null;
  }
}

// Idempotentes las dos: repetir un alta devuelve la misma fila y borrar algo
// que no estaba marcado también responde 200.
export async function addFavorite(type, id) {
  await axios.post(__BR_FAVORITES__, { type, id: Number(id) }, { headers: favoritesHeaders() });
}

export async function removeFavorite(type, id) {
  await axios.delete(`${__BR_FAVORITES__}?type=${type}&id=${Number(id)}`, { headers: favoritesHeaders() });
}

// Fichas de los expositores del evento. Se pide una sola vez y se cruza por id
// con exhibitor.idExhibitor de cada asistente — cruce exacto, sin matchear por
// nombre (los asistentes escriben `company` a mano y solo coincide la mitad).
export async function getExhibitors() {
  try {
    const { data } = await axios.get(__BR_EXHIBITORS__, {
      headers: {
        registrationCode: MyStorage.getPersonRegistrationCode(),
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
        token: MyStorage.getJwtToken(),
      },
    });
    return Array.isArray(data) ? data.filter((e) => !e.deleted) : [];
  } catch (error) {
    console.warn("getExhibitors falló", error && error.message);
    return [];
  }
}

// Catálogo de campos extra del expositor (VisibleInApp). No es fatal: sin
// formulario de expositor el endpoint devuelve [] y el filtro no se muestra.
export async function getExhibitorExtraFieldsSchema() {
  try {
    const { data } = await axios.get(__BR_EXHIBITOR_EXTRAFIELDS_SCHEMA__, {
      headers: {
        registrationCode: MyStorage.getPersonRegistrationCode(),
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
        token: MyStorage.getJwtToken(),
      },
    });
    return Array.isArray(data) ? data : [];
  } catch (error) {
    // 404/500 acá no debe romper el directorio; solo desactiva el filtro.
    console.warn("extraFieldsSchema no disponible", error && error.message);
    return [];
  }
}

export async function getBussinesRoundConfiguration() {
  try {
    const { data } = await axios.get(__BR_CONFIGURATION__);
    // return Number(data.days[0].businessRoundType)
    return data;
  } catch (error) {
    handleError(error, "getBussinesRoundConfiguration");
    throw error;
  }
}

export async function blockSlot(meetingStartDateTime, meetingEndDateTime) {
  try {
    const body = {
      id: 0,
      idRegistrationRequester: MyStorage.getIdRegistration(),
      meetingStartDateTime,
      meetingEndDateTime,
    };

    await axios.post(__BR_SLOT_BLOCK__, body, {
      headers: {
        registrationCode: MyStorage.getPersonRegistrationCode(),
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
        token: MyStorage.getJwtToken(),
      },
    });

    return true;
  } catch (error) {
    handleError(error, "blockSlot - Bloquear horario");
    return error;
  }
}

export async function unblockSlot(slotId) {
  try {
    const body = {
      id: slotId,
      idRegistrationRequester: MyStorage.getIdRegistration(),
    };
    await axios.post(__BR_SLOT_UNBLOCK__, body, {
      headers: {
        registrationCode: MyStorage.getPersonRegistrationCode(),
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
        token: MyStorage.getJwtToken(),
      },
    });
  } catch (error) {
    handleError(error, "unblockSlot - Desbloquear horario");
    return error;
  }
}

export async function rejectOrCancelMeeting(slotId, responseMessage) {
  try {
    const body = {
      id: slotId,
      responseNote: responseMessage,
    };
    await axios.post(__BR_DECLINE_MEETING__, body, {
      headers: {
        registrationCode: MyStorage.getPersonRegistrationCode(),
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
        token: MyStorage.getJwtToken(),
      },
    });
  } catch (error) {
    handleError(error, "rejectOrCancelMeeting - Rechazar / Cancelar solicitud");
    return error;
  }
}

export async function acceptMeeting(slotId, responseMessage) {
  try {
    const body = {
      id: slotId,
      responseNote: responseMessage,
    };
    await axios.post(__BR_ACCEPT_MEETING__, body, {
      headers: {
        registrationCode: MyStorage.getPersonRegistrationCode(),
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
        token: MyStorage.getJwtToken(),
      },
    });
  } catch (error) {
    handleError(error, "acceptMeeting - Aceptar solicitud");
    return error;
  }
}

export async function requestMeeting(
  responseMessage,
  meetingStartDateTime,
  meetingEndDateTime,
  idRegistrationRequestee,
  idMeetingRoom,
  extendedMeeting
) {
  try {
    const body = {
      requestNote: responseMessage,
      meetingStartDateTime,
      meetingEndDateTime,
      idRegistrationRequestee,
      idRegistrationRequester: MyStorage.getIdRegistration(),
      idMeetingRoomSelected: idMeetingRoom,
      extendedMeeting,
    };
    const { data } = await axios.post(__BR_REQUEST_MEETING__, body, {
      headers: {
        registrationCode: MyStorage.getPersonRegistrationCode(),
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
        token: MyStorage.getJwtToken(),
      },
    });
    return data;
  } catch (error) {
    handleError(error, "requestMeeting - Solicitud de reunion");
    const response = {
      success: false,
      code: extractApiErrorCode(error),
      message: extractApiErrorMessage(error),
    };
    throw response;
  }
}

export async function getJointCalendar(idRegistrationRequestee) {
  try {
    const url = `${__BR_AVAILABLE_MEETINGS_SLOTS__}${MyStorage.getIdRegistration()}/${idRegistrationRequestee}`;
    const { data } = await axios.get(url, {
      headers: {
        registrationCode: MyStorage.getPersonRegistrationCode(),
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
        token: MyStorage.getJwtToken(),
      },
    });

    const meetingDays = [];
    const meetings = [];

    data.forEach((slot) => {
      const date = slot.meetingStartDateTime.split("T")[0];
      if (!meetingDays.includes(date)) {
        meetingDays.push(date);
      }
    });

    meetingDays.forEach((day) => {
      const dayMeetings = data.filter(
        (slot) =>
          slot.meetingStartDateTime.split("T")[0] === day &&
          slot.status.toLowerCase() === "notset"
      );
      meetings.push({
        date: day,
        meetings: dayMeetings,
      });
    });

    return meetings;
  } catch (error) {
    handleError(
      error,
      "getJointCalendar - Pedido de horarios disponibles para solicitar reunión"
    );
    // OJO: acá había un `return error`, o sea que ante cualquier fallo la
    // promesa RESOLVÍA con un objeto Error en vez de rechazar. El consumidor lo
    // guardaba como si fuera el calendario y `(jointCalendar || []).find(...)`
    // reventaba con "find is not a function" — el Error es truthy, así que el
    // `|| []` no lo salvaba. Lanzándolo, el .catch del hook hace su trabajo y
    // el calendario queda en su valor inicial ([]).
    throw error;
  }
}

export async function blockCalendar(cancelMessage) {
  try {
    await axios.post(
      __BR_CALENDAR_BLOCK__,
      {
        idRegistration: Storage.getIdRegistration(),
        responseNote: cancelMessage,
      },
      {
        headers: {
          token: Storage.getJwtToken(),
          registrationCode: Storage.getPersonRegistrationCode(),
        },
      }
    );
    store.dispatch(setBusinessRoundEnabled(false));
    return true;
  } catch (error) {
    console.log("Could not disable bs rounds");
    console.log(error);
    return false;
  }
}

export async function exportCalendarToPdf() {
  try {
    const { data } = await axios.post(
      __BR_EXPORT_CALENDAR_PDF__,
      null,
      {
        headers: {
          registrationCode: Storage.getPersonRegistrationCode(),
          token: Storage.getJwtToken(),
        },
      }
    );
    return data;
  } catch (error) {
    handleError(error, "exportCalendarToPdf - Enviar agenda por email");
    throw error;
  }
}

export async function unBlockCalendar() {
  try {
    await axios.post(
      __BR_CALENDAR_UNBLOCK__,
      {
        idRegistration: Storage.getIdRegistration(),
      },
      {
        headers: {
          token: Storage.getJwtToken(),
          registrationCode: Storage.getPersonRegistrationCode(),
        },
      }
    );
    store.dispatch(setBusinessRoundEnabled(true));
    return true;
  } catch (error) {
    console.log("Could not enable bs rounds");
    console.log(error);
    return false;
  }
}

function handleError(error, requestingMethod) {
  const { response, request } = error;

  const logDescription = {
    level: "ERROR",
    process: requestingMethod,
    IdEvent: MyStorage.getIdEvent(),
  };

  if (request || response) {
    logDescription.AdditionalInformation = JSON.stringify({
      registrationCode: MyStorage.getPersonRegistrationCode(),
      token: MyStorage.getJwtToken(),
    });
  }

  if (response) {
    logDescription.exceptionType = response.status + response.statusText;
    logDescription.title = response.data.message;
  } else if (request) {
    logDescription.title = "No se recibio respuesta del servidor";
  } else {
    logDescription.title = "Error de ejecución";
  }

  try {
    axios.post(__API_LOGS__, logDescription);
  } catch (err) {
    console.error(err);
  }
}
